export default "__VITE_ASSET__D3rHgE7o__"